export type BoardWipState = "below" | "reached" | "exceeded";

export function normalizeBoardWipLimits(columns: string[], limits: Record<string, number | undefined> = {}): Record<string, number> {
  return Object.fromEntries(columns.flatMap(column => {
    const value = Math.floor(Number(limits[column]));
    return Number.isFinite(value) && value > 0 ? [[column, value]] : [];
  }));
}

export function boardWipState(openTasks: number, limit?: number): BoardWipState | null {
  if (!limit || limit < 1) return null;
  if (openTasks > limit) return "exceeded";
  if (openTasks === limit) return "reached";
  return "below";
}
